import { AxiosResponse } from "axios"
import { useState } from "react"
import FileSaver from "file-saver";

interface Props {
    onError?:(error:Error)=>void
}

export const useDownload = (props?:Props) => {
    const [isLoading,setIsLoading] = useState(false);
    const startDownload = (promise:Promise<AxiosResponse>,name:string) => {
        setIsLoading(true);
        promise.then((result:AxiosResponse)=>{
            FileSaver.saveAs(new Blob([result.data]), name);
        })
        .catch(props?.onError)
        .finally(()=>{setIsLoading(false)})
    }
    return{
        startDownload,
        isLoading
    }
}